/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchAddressResultDto } from '../../models/search-address-result-dto';

export interface SearchForLocality$Params {
  locality: string;
}

export function searchForLocality(
  http: HttpClient,
  rootUrl: string,
  params: SearchForLocality$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchAddressResultDto>> {
  const rb = new RequestBuilder(rootUrl, searchForLocality.PATH, 'get');
  if (params) {
    rb.query('locality', params.locality, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchAddressResultDto>;
      }),
    );
}

searchForLocality.PATH = '/search/address/locality';
